<div class="otp-container">
    <input *ngFor="let val of otpValues; let i = index; trackBy: trackByIndex" #otpInput type="text" inputmode="numeric"
        maxlength="1" [(ngModel)]="otpValues[i]" (input)="onInput(i, $event)" (keydown)="onKeyDown(i, $event)"
        (paste)="onPaste($event)" class="otp-input" [class.filled]="otpValues[i]">
</div>